export default {
  API_ENDPOINT: 'https://shrouded-springs-60057.herokuapp.com/api',
  TOKEN_KEY: 'blogful-client-auth-token',
}
